(function () {
  'use strict';

  const endpoint = '/apps/plant-x-me/api/analytics/events';
  const allowedContextKeys = new Set([
    'guide_id', 'depth', 'result_id', 'pdf_type', 'source', 'destination',
    'event_type', 'result_count', 'query_length'
  ]);

  function analyticsAllowed() {
    try {
      return Boolean(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (error) {
      return false;
    }
  }

  function sessionId() {
    try {
      let value = window.sessionStorage.getItem('pxm-analytics-session-v1');
      if (!value) {
        value = window.crypto && typeof window.crypto.randomUUID === 'function'
          ? window.crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
        window.sessionStorage.setItem('pxm-analytics-session-v1', value);
      }
      return value;
    } catch (error) {
      return '';
    }
  }

  function cleanContext(context) {
    const output = {};
    Object.entries(context || {}).forEach(function (entry) {
      const key = entry[0];
      const value = entry[1];
      if (!allowedContextKeys.has(key) || value === undefined || value === null) return;
      output[key] = String(value).slice(0, 160);
    });
    return output;
  }

  function track(name, context) {
    if (!analyticsAllowed()) return Promise.resolve(false);
    const sid = sessionId();
    if (!sid) return Promise.resolve(false);
    const payload = JSON.stringify({
      name: name,
      sessionId: sid,
      path: window.location.href,
      context: cleanContext(context)
    });
    return window.fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      credentials: 'same-origin',
      keepalive: true
    }).then(function (response) {
      return response.ok;
    }).catch(function () {
      return false;
    });
  }

  window.PxmAnalytics = { track: track, allowed: analyticsAllowed };

  function init() {
    const guidePage = document.querySelector('[data-pxm-guide-page][data-guide-id]');
    if (guidePage) track('guide_open', { guide_id: guidePage.dataset.guideId, source: 'seo_page' });

    const garden = document.querySelector('[data-pxm-garden-root]');
    if (garden) track('garden_open', { source: 'garden_page' });

    document.addEventListener('click', function (event) {
      const bridge = event.target.closest('[data-pxm-shop-bridge]');
      if (bridge) {
        track('shop_bridge_click', {
          source: bridge.dataset.pxmBridgeSource || 'tool',
          destination: bridge.getAttribute('href') || '/pages/nos-plantes',
          guide_id: bridge.dataset.pxmGuideId || ''
        });
      }
      const auth = event.target.closest('[data-pxm-auth-url], [data-pxm-login], a[href*="/account/login"]');
      if (auth && document.querySelector('[data-pxm-garden-root], [data-pxm-space-root]')) {
        track('garden_auth_click', { source: 'garden' });
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
